import React, { useContext, useEffect, useState } from "react";
import {fireAuth} from "../firebase";
import {db} from '../firebase'
import { AppContext } from "./AppContext";
import {AppContextInterface} from "./AppContext"

interface IUser {
    email: string | null,
    displayName: string | null,
    photoURL: string | null,
    uid?: string | null | undefined
}

interface IAuth {
    user: IUser,
    isUser: boolean | null
}

interface IContext {
    auth: IAuth,
    setAuth: React.Dispatch<React.SetStateAction<IAuth>>
}

export const AuthContext = React.createContext<IContext | null>(null);

interface IChild {
    children: JSX.Element
}


export const AuthProvider = ({ children } :IChild) => {

    const [auth, setAuth] = useState<IAuth>({user: {
            email: JSON.parse(localStorage.getItem('user')!) ? JSON.parse(localStorage.getItem('user')!)[0] : null,
            displayName: JSON.parse(localStorage.getItem('user')!) ? JSON.parse(localStorage.getItem('user')!)[1] : null,
            photoURL: JSON.parse(localStorage.getItem('user')!) ? JSON.parse(localStorage.getItem('user')!)[2] : null
        }, isUser: JSON.parse(localStorage.getItem('user')!) ? JSON.parse(localStorage.getItem('user')!)[3] : null,
    });

    const app = useContext(AppContext)

    useEffect(() => {
        fireAuth.onAuthStateChanged((user:any) => {
            if (user) {
                db.collection('users').doc(user.uid).collection('userData').doc('userData').get().then((doc) => {
                    if (doc.exists) {
                        if (doc.data()!.displayName) {
                            user = {...user, displayName: doc.data()!.displayName}
                        }
                        if (doc.data()!.photoURL) {
                            user = {...user, photoURL: doc.data()!.photoURL}
                        }
                    } else {
                        let userPic = user.photoURL
                        userPic = userPic.split("=", 1) + "=s250"
                        user = {...user, photoURL: userPic}
                    }
                    setAuth({user: user, isUser: true})
                    localStorage.setItem('user', JSON.stringify([user.email, user.displayName, user.photoURL , true]))
                })

                db.collection('users').doc(user.uid).collection('userInvData').doc('userInvData').get().then((doc) => {
                    if (doc.exists) {
                        app?.setApp({...app.app, firstTime:false, myData: doc.data() as AppContextInterface["myData"]})
                    } else {
                        app?.setApp({...app.app, firstTime:true})
                    }
                })

            } else {
                setAuth({user: {email: null, displayName: null, photoURL:null}, isUser: false})
                localStorage.setItem('user', JSON.stringify(false))
            }

        });
// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.user?.displayName, auth.user?.photoURL]);


    return (
    <AuthContext.Provider value={{auth, setAuth}}>
        {children}
    </AuthContext.Provider>
  );
};